export default {
  apiKey: "your_firebase_api_key",
  authDomain: "your_firebase_auth_domain",
  databaseURL: "your_firebase_database_url",
  projectId: "your_firebase_project_id",
  storageBucket: "your_firebase_storage_bucket",
  messagingSenderId: "your_firebase_messaging_sender_id",
};
